import React from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import { SectionTitle } from 'Components/Section/SectionTitle'
import { Checkbox } from './../../../../../Components/Form/Checkbox'
import injectStyles from 'react-jss'
import { updateAmbassadorById } from 'Reducers/Ambassador/actions'
import { connect } from 'react-redux'
import { styles } from './style'

const BankDetailsSectionView = ({
  ambassadorId,
  paymentDetails,
  classes,
  updateAmbassadorById,
  withholdPay,
}) => {
  const toggleWithholdPay = () => {
    updateAmbassadorById(ambassadorId, { withhold_pay: !withholdPay })
  }

  return (
    <Grid fluid>
      <Row>
        <Col xs={12}>
          <SectionTitle>Bank Details</SectionTitle>
        </Col>
        <div className={classes.withholdContainer}>
          <label className={classes.withoutLabel}>Withhold pay</label>
          <Checkbox
            className={classes.withoutCheckbox}
            input={{
              onClick: toggleWithholdPay,
              checked: withholdPay,
            }}
          />
        </div>
      </Row>
      {paymentDetails && (
        <Row>
          <Col xs={3}>
            <p className="col-title">Bank Name</p>
            <p>{paymentDetails.accountName || '-'}</p>
          </Col>
          <Col xs={3}>
            <p className="col-title">BSB</p>
            <p>{paymentDetails.branchNumber || '-'}</p>
          </Col>
          <Col xs={3}>
            <p className="col-title">Account Number</p>
            <p>{paymentDetails.accountNumber || '-'}</p>
          </Col>
        </Row>
      )}
    </Grid>
  )
}

const StyledBankDetailsSection = injectStyles(styles)(BankDetailsSectionView)

const ConnectedBankDetailsSection = connect(
  null,
  { updateAmbassadorById },
)(StyledBankDetailsSection)

export default ConnectedBankDetailsSection



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Spies/View/BankDetailsSection.js